import { Typography } from "@quint/ui";
import { isValidElement, type ReactNode, type SVGProps } from "react";
import { IconCircleGradientWrapper } from "./icon-circle-gradient-wrapper";

export const Section = ({
  title,
  description,
  Icon,
}: {
  title: string;
  description: ReactNode;
  Icon: (p: SVGProps<SVGSVGElement>) => JSX.Element;
}) => {
  return (
    <div className="flex flex-col items-center">
      <IconCircleGradientWrapper>
        <Icon />
      </IconCircleGradientWrapper>
      <Typography variant="h6" as="h4" className="mt-10 text-center">
        {title}
      </Typography>
      <div className="mt-2 text-center text-slate-700 dark:text-[#B3BAC0]">
        {isValidElement(description) ? description : <Typography variant="baseRegular">{description}</Typography>}
      </div>
    </div>
  );
};
